var map = {
	"./leader_cs_m.svg": "933d",
	"./leader_de_m.svg": "141b",
	"./leader_en_m.svg": "82ac",
	"./leader_ko_m.svg": "62d7",
	"./leader_ns_m.svg": "2cb5",
	"./leader_pl_m.svg": "ce34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bbd";